'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024$0024anon$002437 from "./presto.types$-Base64-String$$anon$37.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Base64String$() {
  this.c48 = null;
  this.c49 = false;
  this.c46 = null;
  this.c47 = false;
  this.c4a = null;
  this.c4b = false;
}
export { $c_Lpresto_types$Base64String$ as $c_Lpresto_types$Base64String$ };
$p = $c_Lpresto_types$Base64String$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Base64String$;
/** @constructor */
function $h_Lpresto_types$Base64String$() {
}
export { $h_Lpresto_types$Base64String$ as $h_Lpresto_types$Base64String$ };
$h_Lpresto_types$Base64String$.prototype = $p;
$p.nN = (function() {
  if ((!this.c49)) {
    this.c48 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c49 = true;
  }
  return this.c48;
});
$p.r2 = (function() {
  if ((!this.c47)) {
    this.c46 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c47 = true;
  }
  return this.c46;
});
$p.cJ0 = (function() {
  if ((!this.c4b)) {
    this.c4a = new $j_presto$002etypes$0024$002dBase64$002dString$0024$0024anon$002437.$c_Lpresto_types$Base64String$$anon$37(this);
    this.c4b = true;
  }
  return this.c4a;
});
var $d_Lpresto_types$Base64String$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Base64String$, "presto.types$Base64String$", ({
  Yv: 1,
  D: 1
}));
export { $d_Lpresto_types$Base64String$ as $d_Lpresto_types$Base64String$ };
var $n_Lpresto_types$Base64String$;
function $m_Lpresto_types$Base64String$() {
  if ((!$n_Lpresto_types$Base64String$)) {
    $n_Lpresto_types$Base64String$ = new $c_Lpresto_types$Base64String$();
  }
  return $n_Lpresto_types$Base64String$;
}
export { $m_Lpresto_types$Base64String$ as $m_Lpresto_types$Base64String$ };
//# sourceMappingURL=presto.types$-Base64-String$.js.map
